import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MoneyPipe } from '../../infrastructure/helpers/money.pipe';
import { PriceComponent } from './price/price.component';

@NgModule({
  declarations: [
    MoneyPipe,
    PriceComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MoneyPipe,
    PriceComponent,
  ],
})
export class AppCommonModule {}
